import { Editor, Transforms } from 'slate'
import { v4 } from 'uuid'
import { ElementWithType } from '../../../../../../utils/types'

export const clearEditor = (editor) => {
  const [docs] = Editor.nodes(editor, {
    at: [0],
    match: (n: ElementWithType) => n.type === 'doc'
  })
  let docsCopy
  if (docs) {
    docsCopy = JSON.parse(JSON.stringify(docs[0]))
  } else {
    docsCopy = {
      type: 'doc',
      attrs: {},
      children: []
    }
  }
  docsCopy.children = [{ type: 'p', uid: v4().split('-').join(''), attrs: {}, children: [] }]
  Transforms.removeNodes(editor, { at: [0] })
  Transforms.insertNodes(editor, [docsCopy], { at: [0] })
  Transforms.select(editor, [0])
}
